import {Graphics, Sprite} from 'pixi.js';
import {Back, gsap} from 'gsap';
import {Pivot} from '../../../../../../../utils/Pivot';
import {PointsButton} from './points_buttons/PointsButton';
import MessageHelper from '../../../../../../../../../../helpers/MessageHelper';

export class PointsButtons extends Sprite
{
    graphicsBg: Graphics;
    appearTween: gsap.core.Tween | undefined;
    increaseButton: PointsButton | undefined;
    decreaseButton: PointsButton | undefined;
    value: number = 0;

    constructor(private playerId: string) {
        super();

        this.graphicsBg = new Graphics();

        this.addChild(this.graphicsBg);

        this.initialize();
    }

    private _appearProgress: number = 0;

    get appearProgress(): number {
        return this._appearProgress;
    }

    set appearProgress(val: number) {
        this._appearProgress = val;
        this.graphicsBg.clear();
        this.graphicsBg.beginFill(0x3F4246, val);
        let top: number = -23 - val * (65 - 23);
        let bottom: number = -top;
        this.graphicsBg.drawRoundedRect(-23, top, 46, bottom - top, 23);
        this.graphicsBg.endFill();
        this.increaseButton!.y = top + 23;
        this.decreaseButton!.y = bottom - 23;
    }

    appear(value: boolean = true): void {
        this.appearTween && this.appearTween.pause();
        this.appearTween = gsap.to(this, {
            appearProgress: value ? 1 : 0,
            duration: .3,
            ease: value ? Back.easeOut : Back.easeIn
        });
    }

    private async initialize(): Promise<void> {
        this.increaseButton = new PointsButton('/images/video_seats/points_inc.svg', this.onClickIncrease.bind(this));
        this.decreaseButton = new PointsButton('/images/video_seats/points_dec.svg', this.onClickDecrease.bind(this));

        this.addChild(this.increaseButton);
        this.addChild(this.decreaseButton);

        Pivot.centerPivot(this.increaseButton);
        Pivot.centerPivot(this.decreaseButton);
        this.appearProgress = 0;
    }

    private onClickIncrease() {
        this.sendPoints(++this.value);
    }

    private onClickDecrease() {
        this.sendPoints(--this.value);
    }

    private sendPoints(points: number): void {
        const data = {
            playerId: this.playerId,
            points
        };
        MessageHelper.changePlayerPointsMessage(data);
    }
}
